"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerModal = exports.trigger = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const set_1 = __importDefault(require("lodash/set"));
const initialState = {
    ADMIN: {
        experts: {
            license: false,
            certificate: false,
            education: false,
            expertize: false,
            services: false,
            languages: false,
            states: false,
            queryLogs: false,
            save: {
                open: false,
                data: null,
            },
        },
        whatsNew: {
            delete: {
                open: false,
                data: null,
            }
        }
    },
    snackbar: {
        type: null,
        text: null
    }
};
const modalsSlice = toolkit_1.createSlice({
    name: 'modals',
    initialState: initialState,
    reducers: {
        trigger: (state, action) => {
            const { key, val, root = 'ADMIN' } = action.payload;
            if (!root) {
                set_1.default(state, key, val);
            }
            else {
                set_1.default(state[root], key, val);
            }
            return state;
        },
    }
});
exports.trigger = modalsSlice.actions.trigger;
const triggerModal = (props) => dispatch => dispatch(exports.trigger(props));
exports.triggerModal = triggerModal;
exports.default = modalsSlice.reducer;
